module.exports = __webpack_public_path__ + "../resources/img/ic_quick_guide.368a19dd.svg";